import React, { useState, useEffect, useRef, useCallback, memo } from "react";
import { Link, Navigate } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import Immigration from "../assets/images/public-pages/why-sydney.png";
import SimpleReactValidator from "simple-react-validator";
import { store } from "store/index";
import { setAlert } from "action/index.js";
import API from "api.js";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import BannerHeader from "components/PublicPagesReusable/BannerHeader";
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import InfoSection from "components/PublicPagesReusable/InfoSection";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import tickIcon from "/images/web-new-images/icons/green-check.svg";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import ExpertTrainers from "../assets/images/public-pages/Expert-Trainers.svg";
import OnlineFlexibility from "../assets/images/public-pages/Online-Flexibility.svg";
import ProvenSuccess from "../assets/images/public-pages/Proven-Success.svg";
import PersonalizedFeedback from "../assets/images/public-pages/Personalized-Feedback.svg";
import ComprehensiveResources from "../assets/images/public-pages/Comprehensive-Resources.svg";
import feedback from "../assets/images/public-pages/1-1-feedback.svg";
import Report from "../assets/images/public-pages/report.svg";
import Dialog from "../assets/images/public-pages/dialog.svg";
import Vocab from "../assets/images/public-pages/Vocab.svg";
import ExperiencedIcon from "../assets/images/public-pages/ExperiencedIcon.png";
import HighestIcon from "../assets/images/public-pages/HighestIcon.png";
import MaterialsIcon from "../assets/images/public-pages/MaterialsIcon.png";
import ResourceIcon from "../assets/images/public-pages/ResourceIcon.png";
import SupportIcon from "../assets/images/public-pages/SupportIcon.png";
import DiscussionIcon from "../assets/images/public-pages/DiscussionIcon.png";
import FeeIcon from "../assets/images/public-pages/FeeIcon.png";
import TestEnvironmentIcon from "../assets/images/public-pages/TestEnvironmentIcon.png";
import ExamSkillsSection from "components/PublicPagesReusable/ExamSkillsSection";
import AppPromoSection from "components/PublicPagesReusable/AppPromoSection";
import NaatiCourseCards from "components/PublicPagesReusable/NaatiCourseCards";
import PricingSection from "components/PublicPagesReusable/PricingSection";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";
import FaqSection from "components/PublicPagesReusable/FaqSection";
// import FameWallPte from "../components/Frontend/FameWallPte";
// import Testimonial from "../components/Frontend/Testimonial";
// import TestimonialVid from "../components/Frontend/VideoPTETestimonial";
// import Slider from "react-slick";
// import VideoTuts from "../components/Frontend/VideoTuts";
// import VideoTestimonial from "../components/Frontend/VideoNaatiTestimonial";

const Pte = memo(() => {
  // State declarations
  const [isActive, setIsActive] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [course, setCourse] = useState("PTE On-Campus");
  const [lang, setLang] = useState("Hindi");
  const [query, setQuery] = useState("");
  const [flag, setFlag] = useState(false);
  const [loginLock, setLoginLock] = useState(false);
  const [readMoreFlag, setReadMoreFlag] = useState(false);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);

  // Validator reference
  const validator = useRef(new SimpleReactValidator());

  // Force re-render for validator messages
  const forceUpdate = useCallback(() => {
    setForceUpdateKey((prev) => prev + 1);
  }, []);

  // Lifecycle: componentDidMount
  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactPixel.init("2474090032742391");
    ReactPixel.init("197333187452630");
    ReactPixel.pageView();
  }, []);

  // Event handlers
  const handleClick = useCallback(() => {
    setIsActive((prev) => !prev);
  }, []);

  const changeInput = useCallback((e) => {
    const { name, value } = e.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "phone":
        setPhone(value);
        break;
      case "course":
        setCourse(value);
        break;
      case "lang":
        setLang(value);
        break;
      case "query":
        setQuery(value);
        break;
      default:
        break;
    }
    // handleClick = () => {
    //   this.setState((prevState) => ({
    //     isActive: !prevState.isActive,
    //   }));
    // };
  }, []);
  
  const changeReadMore = useCallback(() => {
    setReadMoreFlag((prev) => !prev);
  }, []);

  const hitApi = useCallback(async () => {
    if (loginLock) return;

    if (!validator.current.allValid()) {
      validator.current.showMessages();
      forceUpdate();
      return;
    }

    setLoginLock(true);

    const bodyFormData = new FormData();
    bodyFormData.set("email", email);
    bodyFormData.set("name", name);
    bodyFormData.set("phone", phone);
    bodyFormData.set(
      "message",
      `Lang: ${lang}<br/>course: ${course}<br/>Query: ${query}`,
    );
    bodyFormData.set(
      "data",
      `email: ${email},name: ${name},phone: ${phone},lang: ${lang},course: ${course},query: ${query}`,
    );
    bodyFormData.set("page", "PTE coaching Sydney");

    let res = null;
    try {
      res = await API({
        method: "POST",
        url: "sendOnlinePte",
        data: bodyFormData,
      });
    } catch (error) {
      // Error handled silently as in original
    }
    console.log(res);

    if (res?.status === 200) {
      store.dispatch(
        setAlert({ flag: true, type: 1, message: res.data.message }),
      );
      setName("");
      setEmail("");
      setPhone("");
      setCourse("PTE On-Campus");
      setQuery("");
      setLoginLock(false);
      setFlag(true);
    } else {
      setLoginLock(false);
    }
  }, [loginLock, email, name, phone, lang, course, query, forceUpdate]);

  const submitForm = useCallback(
    (e) => {
      e.preventDefault();
      hitApi();
    },
    [hitApi],
  );

  // Redirect if flag is true
  if (flag) {
    return <Navigate to="/thank-you" replace />;
  }

  const customslider = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  const bannerTitle = () => {
    return (
      <p className="FS56FW500 top-section-text">
        Master
        <span className="text-success"> NAATI CCL & Fast-Track </span> Your PR
        <br />
        Application With Sydney's Best Coaching Centre
      </p>
    );
  };

  const blueBoxText = () => {
    return (
      <div className="light-blue-box">
        Master your English skills with personalized PTE Online Training
        designed for non-native speakers, test takers, and students. Achieve
        high PTE scores, improve your English proficiency, and gain the
        confidence to reach your study, work, or residency goals through our
        comprehensive PTE Online Course.
      </div>
    );
  };

  const subTitleSection = () => {
    return (
      <p className="sub-title white">
        Professional NAATI CCL training that opens doors to your Australian
        permanent residency goals.
      </p>
    );
  };
  const images = [
    {
      src: "/images/web-new-images/emojis/Updated/Score01.png",
      alt: "score-1",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score02.png",
      alt: "score-2",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score03.png",
      alt: "score-3",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score04.png",
      alt: "score-4",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score05.png",
      alt: "score-5",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score06.png",
      alt: "score-6",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score07.jpg",
      alt: "score-7",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score08.jpg",
      alt: "score-8",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score09.jpg",
      alt: "score-9",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score10.jpg",
      alt: "score-10",
    },
  ];
  const heroDescriptionSection = () => {
    return (<p className="sub-title text-center FS16FW500">
      Prepare for the NAATI CCL exam with confidence and get one step closer to securing Australian Permanent Residency. <br/><br/>
      At Sydney's leading NAATI CCL coaching centre, we offer specialized training specifically designed for students, aspirants,<br/> 
      and international residents aiming to gain those crucial five bonus PR points.<br/><br/>

      Develop your bilingual interpretation skills, master the NAATI CCL exam format, and overcome challenges with our<br />
      comprehensive and affordable programs. <br /><br/>
      Don't let lack of resources or ineffective preparation hold you back, it's time to succeed!
      
    </p>)
  }
  const contentSection = () => {
    return (
   <h3 className="top-section-text FS40FW600">
    Why Sydney Is The Best <br/> Location For
   <span className="text-success FS40FW600">NAATI CCL<br/> Coaching Classes</span>
    </h3>
    )
  }
  const skillAreaTitle = () => {
    return (
      <p className="top-section-text mb-4 white FS40FW600">
        <span className="text-success FS40FW600">Why Choose Our NAATI CCL </span><br/>Training Centre in Sydney?
      </p>
    )
  }
  const lifestyleCards = [
    {
      title: "Expert Trainers",
      text: "Learn from NAATI-certified professionals with years of experience in coaching students to success.",
      color: "#48A75C",
      img: ExpertTrainers
    },
    {
      title: "Customized Feedback",
      text: "Receive personalized performance analysis to identify weak spots and make improvements.",
      color: "#0286FF",
      img: PersonalizedFeedback
    },
    {
      title: "Flexible Options",
      text: "Choose between in-person classes at our Sydney training centre or convenient online sessions.",
      color: "#7F56D9",
      img: OnlineFlexibility
    },
    {
      title: "Comprehensive Resources",
      text: "Access dialogue exercises, vocabulary lists, and mock tests designed for the NAATI CCL exam.",
      color: "#FFB02C",
      img: ComprehensiveResources
    },
    {
      title: "Success Stories",
      text: "Join thousands of students who have successfully passed the NAATI CCL exam and gained their PR points with our support.",
      color: "#FFB02C",
      img: ProvenSuccess
    },
  ];

  const skillAreaTitle2 = () => {
    return (
      <p className="top-section-text mb-4 FS40FW600">Our <span className="text-success FS40FW600"> NAATI CCL </span> Training <br /> Program in Sydney</p>
    )
  }
  const naatiCourseCards = [
    {
      title: "Online Intensive Course",
      features: [
        "10 online sessions with an additional 1-hour consultation",
        "Flexible scheduling for busy students and professionals",
        "Same expert-led training from the comfort of your home",
      ],
      bottomParagraph: () => {
        return (<p className="mt-3 text-muted plus-sans FS16FW500 fw-400">Students who can come to our campus can enroll in our on-campus program. Students who are unable to attend our on-campus course due to some reasons can enroll in our online course.</p>)
      },
      bottomBtnText: "Enroll Now",
      bottomBtnFunction: () => {console.log("Online course enroll")}
    },
    {
      title: "8 - Weeks Intensive Course",
      isPopular: true,
      features: [
        "Online 1-1 session course",
        "Live instruction and small group settings for personalized attention",
        "Comprehensive materials and face-to-face coaching",
      ],
      bottomBtnText: "Enroll Now",
      bottomBtnFunction: () => {console.log("Online course enroll")}
    },
    {
      title: "Designed to Combat Common Struggles",
      titleLarge: true,
      features: [
        "Lack of reliable preparation resources",
        "Difficulty managing busy schedules",
        "Limited practice opportunities with real test simulations",
        "Fear of failing and losing PR eligibility",
      ],
      bottomParagraph: () => {
        return (<p className="mt-3 text-muted plus-sans FS16FW500 fw-400">With both course formats, you'll not only develop the skills needed to pass but also build confidence for exam success.</p>)
      },
      bottomBtnText: "Enroll Now",
      bottomBtnFunction: () => {console.log("Online course enroll")}
    },
  ];

    const pricingSectionData = {
    title: "Choose Your Perfect",
    highlight: "NAATI CCL Preparation",
    subtitle: "Package",
    note: "Choose your package that fits your goals. Starting from just $29",

    plans: [
      {
        name: "Beginner",
        price: "$119",
        priceByText:'/ 2 Months',
        features: [
          { text: "Real Exam Practice Material", active: true },
          { text: "Full Vocabulary Access", active: true },
          { text: "Full Length Mock Tests", active: true },
          { text: "Last Minute Practice", active: true },
          // { text: "Unlimited full mock tests with scoring", active: true },
          // { text: "Unlimited comprehensive mock tests with scoring", active: true },
          { text: "1 Mock test with Scorecard & Feedback on Improvement", active: false },
        ],
        button: "Enroll Now",
      },
      {
        name: "Pro",
        price: "$189",
        priceByText:'/ 2 Months',
        // badge: "BEST SELLER",
        features: [
          { text: "Real Exam Practice Material", active: true },
          { text: "Full Vocabulary Access", active: true },
          { text: "Full Length Mock Tests", active: true },
          { text: "Last Minute Practice", active: true },
          // { text: "Unlimited full mock tests with scoring", active: true },
          // { text: "Unlimited comprehensive mock tests with scoring", active: true },
          { text: "1 Mock test with Scorecard & Feedback on Improvement", active: true },
        ],
        button: "Enroll Now",
      },
      {
        name: "Online Coaching",
        badge: "MOST POPULAR",
        highlightCard: true,
        description:
          "Get the ultimate preparation with live expert guidance.",
        features: [
          {
            title: "Live Virtual Classes",
            desc: "Join expert-led sessions focusing on each component of the exam",
          },
          {
            title: "Personalized Feedback",
            desc: "Receive detailed analysis of your performance with specific improvement strategies",
          },
          {
            title: "Direct Trainer Access",
            desc: "Get your questions answered directly by our experienced instructors",
          },
          {
            title: "Priority Support",
            desc: "Fast-track assistance whenever you face challenges in your preparation",
          },
        ],
        button: "Book Your Trail Class",
      },
    ],
  };

     const faqQuestions = [
    {
      question: "How long does it take to prepare for the NAATI CCL exam?",
      answer: "Most students need 4-6 weeks of consistent preparation, but with our intensive 8-week course at our Sydney training centre, you'll be thoroughly prepared."
    },
    {
      question: "Do you offer both online and in-person classes in Sydney?",
      answer: "Yes! We offer both an 8-week intensive course with up to 4 classes per week at our Sydney training centre, and a 10-session online intensive course with 1-hour consultation."
    },
    {
      question: "What languages do you offer NAATI CCL preparation for?",
      answer: "We offer preparation in 10 languages: Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, and Sinhalese."
    },
    {
      question: "How can I book a free trial session at your Sydney centre?",
      answer: "You can contact us to register for a free trial session and experience our teaching methodology firsthand."
    },
    {
      question: "Why is Sydney the best location for NAATI CCL coaching?",
      answer: "Sydney is one of the most popular destinations for higher education among international students, with a diverse population and excellent educational infrastructure that makes it ideal for NAATI CCL preparation."
    },
    {
      question: "What makes Language Academy different from other NAATI CCL training centres in Sydney?",
      answer: "We have the highest success rate in Sydney, offer both online and offline courses, provide 100+ audio dialogues, and have NAATI-certified trainers with personalized feedback systems."
    },
    {
      question: "Does NAATI run its own CCL classes in Sydney?",
      answer: "No, the testing body doesn't run any NAATI CCL classes in Sydney of its own. That's why choosing a reputable training centre like Language Academy is essential for proper preparation."
    },
    {
      question: "What is included in your mobile app?",
      answer: "Our app includes vocabulary in 7 categories with 2000+ words, mock tests like real-time exams, 80+ practice dialogues with sample answers, and last-minute preparation packages."
    },
    {
      question: "Do you provide study materials with the course?",
      answer: "Yes, every student gets free CCL books, templates, comprehensive vocabulary lists, and access to our mobile app with all study materials."
    }
  ];
  return (
    <React.Fragment>
      <Helmet>
        <title>PTE Coaching Classes in Sydney | Language Academy</title>
        <meta
          name="twitter:title"
          content="PTE Coaching Classes in Sydney - Language Academy"
        />
        <meta
          property="og:title"
          content="PTE Coaching Classes in Sydney - Language Academy"
        />
        <meta
          name="description"
          content="Join Language Academy's PTE coaching in Sydney for top-notch PTE training. Achieve your goals with comprehensive practice materials and expert instruction."
        />
        <meta
          name="twitter:description"
          content="Are you searching for the best PTE coaching classes in Parramatta that can help you achieve sure-shot success in your exam? Language Academy, the top PTE training institute in Sydney, provides both in-class and online coaching to help the students to improve their scores in the Pearson Test Of English. To get demo classes from the leading PTE Coaching centre, contact at +61 426230061."
        />
        <meta
          property="og:description"
          content="Are you searching for the best PTE coaching classes in Parramatta that can help you achieve sure-shot success in your exam? Language Academy, the top PTE training institute in Sydney, provides both in-class and online coaching to help the students to improve their scores in the Pearson Test Of English. To get demo classes from the leading PTE Coaching centre, contact at +61 426230061."
        />
      </Helmet>
      <div className="new-design">
        <Header />

        <BannerHeader
          title={bannerTitle}
          blueBoxText={blueBoxText}
          subTitle={subTitleSection}
          backgroundColor="#182A4F"
          textColor="white"
          middleSection={() => {
            return (
              <div
                className="banner-img-wrapper"
                style={{ paddingBottom: "232px" }}
              >
                <img
                  className="banner-img"
                  src={"/images/web-new-images/emojis/PTE-sydny.png"}
                  alt="LA"
                />
              </div>
            );
          }}
          btnText={"ENROLL Now and Get Started Today"}
        />

        <div className="fame-wall">
          <ReusableHomePageSlider images={images} />
        </div>
        <div className="d-flex align-items-center gap-3 flex-column pb-4">
          {heroDescriptionSection()}
          <ButtonComp link={"/auth/register"} btnText={"ENROLL Now and Get Started Today"} />
        </div>
        <InfoSection
          title="What Is The NAATI CCL Exam?"
          subtitle="Your Gateway To Australian PR"
          description="The NAATI Credentialled Community Language (CCL) exam is a critical test that evaluates your ability to interpret and translate between English and your chosen language. Passing this test can earn you an extra five points toward your Australian Permanent Residency (PR)."
          buttonText="Start Your NAATI CCL Prep Journey Now"
          buttonAction={() => console.log("Clicked")}
          image="/images/web-new-images//NaatiOnline.svg"
          imageCaption="Introduced in 2018, the NAATI CCL exam has become an essential milestone for aspirants seeking permanent residency points in Australia.<br/><br/>By passing the CCL, candidates earn five additional points on their PR application, a significant boost on the points-based immigration system."
          rightTitle="NAATI CCL Test Basics"
          features={[
            "<strong>Two recorded dialogues</strong> of 300 words each",
            "<strong>30 minutes</strong> to complete the exam",
            "Each dialogue is divided into segments of approximately 35 words, with a total score of <strong> 45 marks </strong> per dialogue",
            "A passing score requires at least <strong>29 marks per dialogue. </strong>",
            "<strong>Offered in 12 languages, </strong>including Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, and Sinhalese",
          ]}
          footerText="The test has a recording of dialogues between people, and test-takers have to listen to these recordings. There are two dialogues in each recording, and each has 35-word short segments, carrying 45 marks. Securing a minimum of 29 is mandatory to qualify for a valid score.<br/><br/> With the right training, including expert coaching, tailored study plans, and mock tests, you can pass the exam, enhance your bilingual communication skills, and take a critical step toward achieving your dream of Australian PR."
        />

        <div className="custom-container py-5">
          <ContentImageSection
            contentSection={contentSection}
            quoteText={
              "Sydney is one of the most popular destinations for higher education among international students. Preparing for NAATI CCL coaching in Sydney helps gain the five precious points towards Australian PR."
            }
            btnClassName="mt-2"
            image={Immigration}
            imageClassName="immigration-test-img"
            btnLink={'/auth/register'}
            btnText={'DISCOVER WHY SYDNEY STUDENTS CHOOSE Us'}
            listBottomText="
            <div>Sydney has many government and private educational institutes, which makes it an excellent place to pursue higher education.<br/><br/>
              Sydney has a diverse population of various nations and ethnicities. Citizens welcome and accommodate any international student with open hearts.<br/><br/>
              This is one of the reasons why NAATI CCL coaching classes in Sydney are the most preferred choices among the entire continent.</div>"
            
          />
        </div>
          <SkillAreas
          skillAreaTitle={skillAreaTitle}
          lifestyleCards={lifestyleCards}
          btnText={"Sign Up For CCL Training in Sydney"}
          skillSubtitle={"Are you struggling to find the right preparation resources to boost your NAATI CCL performance? Unsure where to start or how to prepare effectively for those bonus PR points?"}
          TopMiddleSection={() => {
            return (
              <p className="sub-title text-center FS16FW500 text-white my-5">
                At our NAATI CCL Sydney training center, we understand the challenges that international students and aspirants face.<br/><br/> We are a very popular NAATI CCL training centre in Sydney with the highest success rate. Our proven preparation methods are built to help you succeed by offering:
              </p>
            )
          }}
          MiddleInfoSection={[
            "When you think of taking a NAATI CCL test, you need to understand that NAATI CCL can be taken both online and offline. However, the testing body doesn't run any NAATI CCL classes in Sydney of its own.",
            "Language Academy offers both online and offline courses, which are very helpful in grabbing the five essential points for Australian PR. Your success is our priority! Let us help you make your Australian PR dream a reality.",
          ]}
          />
          <NaatiCourseCards
            skillAreaTitle={skillAreaTitle2}
            cards={naatiCourseCards}
            btnText={"Get Started With The Program Of Your Choice"}
          />
          <ExamSkillsSection
          title="What Makes Our"
          highlight="Sydney Training Centre Stand Out?"
          description={`Our NAATI CCL preparation program covers every critical area to ensure your success:`}
          ctaText="Start Your NAATI CCL Success Plan Today"
          onCtaClick={() => console.log("Clicked")}
          bottomText={`With our focused training approach, you'll prepare smarter and feel more confident when the stakes are high.`}
          cards={[
            {
              icon: Vocab,
              title: "Vocabulary Enhancements",
              content: `
                <div>
                <ul class='feature-list'>
                <li>
                  Extensive language-specific word lists<br/>
                </li>
                <li>
                  Exercises to improve context-based usage
                </li>
                <li>
                  Cultural and terminological insights for the NAATI exam
                </li>
                </ul>
                </div>
              `
            },
            {
              icon: feedback,
              title: "1-ON-1 Feedback",
              content: `
                <div>
                <ul class='feature-list plus-sans'>
                <li>
                  Detailed assessments from NAATI-accredited trainers
                </li>
                <li>
                  Customized strategies to address individual weaknesses
                </li>
                <li>
                  Personalized attention to help you excel
                </li>
                </ul>
                </div>
              `
            },
            {
              icon: Dialog,
              title: "Practice Dialogues",
              content: `
                <div>
                <ul class='feature-list plus-sans'>
                <li>
                  Realistic audio recordings with varying accents
                </li>
                  <li>
                    Exam-style dialogue exercises for hands-on practice
                </li>
                 <li>
                    Comprehensive solutions with expert sample answers
                </li>
                </ul>
                </div>
              `
            },
            {
              icon: Report,
              title: "Mock Exams Under Real Conditions",
              content: `
                <div>
                <ul class='feature-list plus-sans'>
                <li>
                  Simulated time-pressured exams at our Sydney centre
                </li>
                  <li>
                    Feedback-driven improvement tailored to your performance
                </li>
                 <li>
                    Build comfort and familiarity before exam day
                </li>
                </ul>
                </div>
              `
            }
          ]}
          />
         <ExamSkillsSection
          title="Why Choose Language Academy"
          highlight="NAATI CCL"
          subtitle="Exam Preparation In Sydney"
          ctaText="Choose Success With Sydney’s Most Trusted NAATI CCL Training Center"
          onCtaClick={() => console.log("Clicked")}
          cards={[
            {
              icon: ExperiencedIcon,
              title: "Experienced Trainers",
              content: `
                <div>Our certified faculties help you use their expertise in improving your reading, writing, listening, and speaking sections.</div>
              `
            },
            {
              icon: HighestIcon,
              title: "Highest Success Rate",
              content: `
                <div>We continuously involve ourselves personally with every student, which enables them to unleash the potential in them and achieve the highest scores possible.</div>
              `
            },
            {
              icon: MaterialsIcon,
              title: "Free CCL Books",
              content: `
                <div>Every student at Language Academy gets templates to study and understand the best way to approach the exam and leave the best impression.</div>
              `
            },{
              icon: ResourceIcon,
              title: "Latest Resources",
              content: `
                <div>Students can easily access study material and take practice tests through our mobile app. Just in a few taps, they can get started.</div>
              `
            },{
              icon: SupportIcon,
              title: "Online Support",
              content: `
                <div>During the entire class duration, our experts can be reached out to seek any help. They will answer all your questions and help you anywhere you're stuck.</div>
              `
            },{
              icon: DiscussionIcon,
              title: "100+ Audio Dialogues",
              content: `
                <div>We have curated several previous question papers to help our students practice the common questions that are asked frequently.</div>
              `
            },{
              icon: DiscussionIcon,
              title: "Discussion Sessions",
              content: `
                <div>Our experts note the weaknesses and strengths of students during discussion sessions to devise personalized study plans for them.</div>
              `
            },
            {
              icon: FeeIcon,
              title: "Affordable Fees",
              content: `
                <div>Our costs are pocket-friendly so students can easily pay off their fees and improve their scores.</div>
              `
            },{
              icon: TestEnvironmentIcon,
              title: "Real-Time Test Environment",
              content: `
                <div>Our mock tests provide students with the actual experience of taking tests. Students can test their interpretation and communication skills.</div>
              `
            }
          ]}
         />
         <AppPromoSection
          titleHighlight="Language Academy CCL"
          title="Mobile Application Prepare Anytime, Anywhere"
          subtitle="Our mobile app gives you the flexibility to prepare for the NAATI CCL exam wherever you are:"
          featuresLeft={[
            {
              icon: "/images/web-new-images/yourApprochIcon.svg",
              title: "Vocabulary In 7 Different Categories",
              description: "A complete list of 2000+ words is included and explained in various native languages along with translations.",
            },{
              icon: "/images/web-new-images/yourApprochIcon.svg",
              title: "Mock Tests Like Real-Time Exam",
              description: "The feel of the actual test environment helps you understand properly what you can expect and how to perform.",
            },{
              icon: "/images/web-new-images/yourApprochIcon.svg",
              title: "Last-Minute Preparation Package",
              description: "Short packages are given with tips to boost your confidence and prepare well before the exam.",
            },
          ]}
          featuresRight={[
            {
              icon: "/images/web-new-images/yourApprochIcon.svg",
              title: "Comprehensive Practice Dialogues",
              description: "Dialogues from different categories and scenarios similar to the ones that came in previous exams are included in it.",
            },
            {
              icon: "/images/web-new-images/yourApprochIcon.svg",
              title: "80+ Practice Dialogues",
              description: "Dialogues with sample responses and answers prepared by certified interpreters are included.",
            },
          ]}
          mobileImg="/images/web-new-images/emojis/Updated/PromoSection.png"
          ctaText="Take Your NAATI CCL Prep To The Next Level"
          onCtaClick={() => console.log("CTA Clicked")}
        />
        <section className="what-you-get py-5">
          <div className="custom-container">

            {/* TOP HEADER */}
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-5 gap-3">
              <h2 className="top-section-text FS40FW600 mb-0">
                What You Will <br/><span className="text-success">Get With Us</span>
              </h2>

              <button className="primary-btn" onClick={() => console.log("Register Now Clicked")}>
                Register For A Free Trial Session <img src={`/images/web-new-images/right-arrow.svg`} alt="Register Now" />
              </button>
            </div>

            {/* CONTENT */}
            <div className="row g-4 align-items-center plus-sans">

              {/* LEFT FEATURES */}
              <div className="col-lg-4 d-flex flex-column gap-4">

                <div className="feature-card p-4 rounded-4 shadow-sm">
                  <h6 className="FS20FW500 fw-700 mb-2 to-unset-transform">{" "}<img src={tickIcon} alt="Check Icon" loading="lazy" fetchpriority="low" /> Full Access to CCL App</h6>
                  <p className="mb-0 text-muted FS16FW500">
                    Practice anytime, anywhere with our powerful mobile platform designed for NAATI CCL success
                  </p>
                </div>

                <div className="feature-card p-4 rounded-4 shadow-sm">
                  <h6 className="FS20FW500 fw-700 mb-2 to-unset-transform"> {" "}<img src={tickIcon} alt="Check Icon" loading="lazy" fetchpriority="low" />
                    Comprehensive Practice Dialogues with Expert Sample Answers
                  </h6>
                  <p className="mb-0 text-muted FS16FW500">
                    Master real exam scenarios with professionally crafted responses that guarantee high scores
                  </p>
                </div>

                <div className="feature-card p-4 rounded-4 shadow-sm">
                  <h6 className="FS20FW500 fw-700 mb-2 to-unset-transform"> {" "}<img src={tickIcon} alt="Check Icon" loading="lazy" fetchpriority="low" />
                    Last-Minute Power Dialogues with Sample Answers
                  </h6>
                  <p className="mb-0 text-muted FS16FW500">
                    Boost your confidence with targeted practice sessions designed for final preparation
                  </p>
                </div>

              </div>

              {/* CENTER IMAGE */}
              <div className="col-lg-4 text-center">
                <img
                  src={Immigration}
                  alt="class"
                  className="img-fluid rounded-4 shadow mb-3"
                />
                <div className="feature-card p-4 rounded-4 shadow-sm">
                  <h6 className="FS20FW500 fw-700 mb-2 to-unset-transform"> {" "}<img src={tickIcon} alt="Check Icon" loading="lazy" fetchpriority="low" />
                    Realistic Mock Tests with Detailed Sample Answers
                  </h6>
                  <p className="mb-0 text-muted FS16FW500">
                    Experience the exact exam environment while learning from perfect response examples
                  </p>
                </div>
              </div>

              {/* RIGHT FEATURES */}
              <div className="col-lg-4 d-flex flex-column gap-4">

                <div className="feature-card p-4 rounded-4 shadow-sm">
                  <h6 className="FS20FW500 fw-700 mb-2 to-unset-transform"> {" "}<img src={tickIcon} alt="Check Icon" loading="lazy" fetchpriority="low" />
                    Realistic Mock Tests with Detailed Sample Answers
                  </h6>
                  <p className="mb-0 text-muted FS16FW500">
                    Experience the exact exam environment while learning from perfect response examples
                  </p>
                </div>

                <div className="feature-card p-4 rounded-4 shadow-sm">
                  <h6 className="FS20FW500 fw-700 mb-2 to-unset-transform"> {" "}<img src={tickIcon} alt="Check Icon" loading="lazy" fetchpriority="low" />
                    Complete Vocabulary Bank with Translation Answers
                  </h6>
                  <p className="mb-0 text-muted FS16FW500">
                    Build an unbeatable word arsenal across all categories tested in NAATI CCL
                  </p>
                </div>

                <div className="feature-card p-4 rounded-4 shadow-sm">
                  <h6 className="FS20FW500 fw-700 mb-2 to-unset-transform"> {" "}<img src={tickIcon} alt="Check Icon" loading="lazy" fetchpriority="low" />
                    Live Practice Sessions with NAATI Certified Interpreters
                  </h6>
                  <p className="mb-0 text-muted FS16FW500">
                    Get real-time coaching from qualified professionals who know exactly what examiners want
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <PricingSection data={pricingSectionData} />
        <AppBannerCustom
          appName="NAATI"
          description="LA CCL"
          mobileImage="/images/web-new-images/HomePageImage/NAATI-app.png"
          playStoreLink={`${import.meta.env.VITE_NAATI_ANDROID_APP_URL}`}
          appStoreLink={`${import.meta.env.VITE_NAATI_IOS_APP_URL}`}
        />
        <FaqSection questions={faqQuestions}/>
      </div>
      <Footer />
    </React.Fragment>
  );
});

export default Pte;
